'use strict';

var _ = require('lodash');
var GridToolbarSystemStatusDemandReinitializationController = function GridToolbarSystemStatusDemandReinitializationController($scope, toolbarGridService, constants) {
  $scope.isReinitializeButtonShown = false;
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  $scope.isReinitDisabled = function () {
    if (_.isEmpty($scope.selectedRows)) {
      return false;
    }
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var marketToRowsMap = loadedData.reduce(function (map, obj) {
      var key = obj.origin + obj.destination;
      var value = map[key];
      if (value === undefined) {
        map[key] = [obj];
      } else {
        value.push(obj);
      }
      return map;
    }, {});
    return !_.every($scope.selectedRows, function (selectedRow) {
      var selectedMarket = selectedRow.origin + selectedRow.destination;
      var rows = marketToRowsMap[selectedMarket];
      if (rows === undefined) {
        return true;
      }
      for (var i = 0; i < rows.length; ++i) {
        var row = rows[i];
        if (_.includes([constants.CALENDAR_INIT_STATUSES.NEW, constants.CALENDAR_INIT_STATUSES.STARTED], row.status)) {
          return false;
        }
      }
      return true;
    });
  };
  $scope.updateIsReinitDisabledFlag = function () {
    $scope.isReinitDisabledFlag = $scope.isReinitDisabled();
  };
  $scope.updateIsReinitDisabledFlag();
  $scope.$on('grid:cellValueChanged', function (event, change, gridId) {
    if (gridId === 'system-status-demand-reinitialization' && _.includes(['origin', 'destination'], change.datafield)) {
      $scope.updateIsReinitDisabledFlag();
    }
  });
  $scope.onRowSelection = function (selectedRows) {
    toolbarGridService.rowSelectionHandler($scope, selectedRows);
    $scope.updateIsReinitDisabledFlag();
  };
  $scope.reInitialize = function () {
    if (toolbarGridService.validateReinitialization($scope.selectedRows)) {
      $scope.$emit('system-status-demand-reinitialization:reinitialize', $scope.selectedRows);
    }
  };
  $scope.addDemandReinit = function (origin, destination) {
    toolbarGridService.addRow($scope, origin, destination);
  };
  $scope.duplicateDemandReinit = function () {
    var propertiesToDuplicate = ['destination', 'startDepartureDate', 'endDepartureDate', 'origin', 'clearDemandAdjsFlag', 'forecastType'];
    toolbarGridService.duplicateRow($scope, propertiesToDuplicate);
  };
  $scope.remove = function () {
    toolbarGridService.removeRow($scope);
  };
  $scope.$on('configuration-status-demand-reinitialization', function () {
    $scope.clearModifiedCells();
  });
  $scope.$on('demand-reinitialization:force-add-row', function (event, rowData) {
    $scope.addDemandReinit(rowData.origin, rowData.destination);
  });
  $scope.getDemandReinitializeButtonTitle = function () {
    return $scope.isReinitDisabledFlag ? 'Another request for at least one of selected markets has not finished processing yet' : 'Reinitialize';
  };
};
GridToolbarSystemStatusDemandReinitializationController.$inject = ['$scope', 'ToolbarGridService', 'SeasonalityConstants'];
module.exports = GridToolbarSystemStatusDemandReinitializationController;